module.exports = require('../dist/components/AuthorByline/AuthorByline');
